module.exports = __webpack_public_path__ + "static/media/tablets.19814a63.svg";